import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1),
  flex: 1,
  minHeight: 0,
};

export const summary: SxStyleFunc<boolean | undefined> = (open) => ({
  background: open ? (p) => p.palette.common.white : (p) => p.palette.grey[200],
  borderRadius: open ? (p) => p.spacing(0.5, 0.5, 0, 0) : (p) => p.spacing(0.5),

  flexDirection: 'row-reverse',
  minHeight: open ? 'initial' : '38px',
  gap: (p) => p.spacing(0.5),

  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },

  '& .MuiAccordionSummary-content': {
    margin: open ? 'initial' : 0,
  },
});

export const badge: SxStyleFunc<boolean | undefined> = () => ({
  fontSize: (p) => p.typography.body4,
  color: (p) => p.palette.grey[700],
});

export const title: SxStyleFunc<boolean | undefined> = (length) => ({
  color: length ? (p) => p.palette.common.black : (p) => p.palette.grey[400],
  fontSize: (p) => p.typography.body3.fontSize,
  fontWeight: 500,
});
export const transferListExcluded: SxStyleFunc<boolean | undefined> = (
  open
) => ({
  flex: open ? 1 : 'unset',
  minHeight: open ? 0 : 'unset',
  display: 'flex',
  flexDirection: 'column',
  borderWidth: open ? '1px' : 'unset',
  borderStyle: open ? 'solid' : 'unset',
  borderColor: open ? (p) => p.palette.grey[300] : 'unset',
  borderRadius: open ? (p) => p.spacing(0.5) : 'unset',
});

export const itemIcon: SxStyleFunc<boolean | undefined> = () => ({
  color: (p) => p.palette.common.black,
});
